import React from 'react'
import Spinner from 'ui-library/spinner/spinner';

function Loader({height}: {height?: string}) {
  return (
    <div className={`w-screen max-w-[1440px] ${height?`h-[${height}]`:"h-screen"} flex items-center justify-center`}>
      <Spinner size="w-16 h-16" color="#FF0302" />
    </div>
  );
}

export default Loader
